module.exports = {
  no: { human: 'Nein', api: 'no' },
  moduleA: { human: 'Baustein A: bis 29 Tage', api: 'moduleA' },
  moduleB: { human: 'Baustein B: 30 bis 50 Tage', api: 'moduleB' }
}
